














import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import * as datadog from "@/shared/datadog";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class OktaSsoError extends Vue {
  @Prop()
  referrer: string;

  @Prop()
  reasonCode: string;

  portalCustomizationStore = usePortalCustomizationStore();

  mounted () {
    if (this.shouldLog()) {
      datadog.log("Error in Okta SSO: Unable to login", { reason: this.reasonCode, referrer: this.referrer }, "error");
    }
  }

  shouldLog (): boolean {
    return (
      this.reasonCode &&
      this.reasonCode !== undefined &&
      this.reasonCode.length > 0 &&
      this.referrer &&
      this.referrer !== undefined &&
      this.referrer.length > 0
    );
  }

  get isLoaded (): boolean {
    return this.portalCustomizationStore.isSupportInfoLoaded;
  }

  get supportPhone (): string {
    return this.portalCustomizationStore.partnerSupportPhone;
  }
}
